var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { combine } from 'zustand/middleware';
import { INITIAL_STATE } from './constants';
export var customActions = function (initialValues) {
    return combine(initialValues, function (setState, getState) { return ({
        getLastNotificationDate: function () {
            var state = getState();
            return state.lastNotificationDate;
        },
        openDrawer: function () {
            setState(function () {
                return { isOpen: true, lastNotificationDate: new Date().toISOString() };
            });
        },
        setOnlyNotRead: function (value) {
            setState(function () {
                return { currentPage: initialValues.currentPage, onlyNotRead: value };
            });
        },
        setLastNotificationDate: function (value) {
            setState(function () {
                return { lastNotificationDate: value };
            });
        },
        nextPage: function () {
            setState(function (state) {
                return { currentPage: state.currentPage + 1 };
            });
        },
        setElementRead: function (value) {
            setState(function (state) {
                if (!value) {
                    state.content.forEach(function (content) {
                        content.content.forEach(function (el) {
                            el.isRead = true;
                        });
                    });
                    return __assign({}, state);
                }
                else {
                    var allNotifications = state.content.map(function (el) { return __spreadArray([], el.content, true); }).flat();
                    var notification = allNotifications.find(function (el) { return el.id === value; });
                    if (notification) {
                        notification.isRead = !notification.isRead;
                    }
                    return __assign({}, state);
                }
            });
        },
        setData: function (value) {
            var _a = value[0], total = _a.total, pageData = _a.pageData, content = _a.content;
            setState(function () {
                var _a;
                return {
                    initialized: true,
                    content: value,
                    lastNotificationDate: (_a = content[0]) === null || _a === void 0 ? void 0 : _a.createdOn,
                    totalPages: Math.ceil((total || 1) / pageData.pageSize),
                };
            });
        },
        closeDrawer: function () {
            setState(function () {
                return __assign({}, INITIAL_STATE);
            });
        },
    }); });
};
